import Vue from 'vue'
import VueTouch from 'vue-touch'
import VueFullPage from 'vue-fullpage.js'
import VueObserveVisibility from 'vue-observe-visibility'
import 'whatwg-fetch'


import App from './App.vue'
import router from './router'
import store from './store'
require('intersection-observer');

// Registered plugins
Vue.use(VueTouch, {
  name: 'v-touch'
})
Vue.use(VueObserveVisibility)
Vue.use(VueFullPage)

// import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
